import { useConfirmationDialog } from '@factorialco/deprecated-design-system'
import { ArchiveSaleInvoiceDocument } from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

export const useArchiveSaleInvoiceDialog = () => {
  const { openDialog } = useConfirmationDialog()

  const [archiveSaleInvoice, {}] = useMutation(ArchiveSaleInvoiceDocument, {
    extractorFn: (data) => data.financeMutations.archiveSaleFinanceFinancialDocument,
    refetchQueries: ['ProjectDetailsPageSaleInvoicesPageInsights'],
    update(cache, { data }) {
      const archivedFinancialDocumentId =
        data?.financeMutations?.archiveSaleFinanceFinancialDocument?.financialDocument?.id
      if (archivedFinancialDocumentId) {
        cache.evict({
          id: cache.identify({
            id: archivedFinancialDocumentId,
            __typename: 'FinanceFinancialDocument',
          }),
        })
      }
    },
  })

  const showArchiveSaleInvoiceDialog = ({
    invoiceId,
    callback,
  }: {
    invoiceId: string
    callback?: () => void
  }) => {
    openDialog({
      title: i18n.t('finance.sale_invoices.delete.delete_invoice'),
      content: i18n.t('finance.sale_invoices.delete.content'),
      illustration: 'delete',
      confirmLabel: i18n.t('finance.sale_invoices.delete.delete_invoice'),
      onConfirm: async () => {
        const result = await archiveSaleInvoice({
          variables: {
            id: invoiceId,
          },
        })

        const handled = handleResult(result, (_errors) => {})

        if (handled.success) {
          app.setFlash({
            type: 'correct',
            message: i18n.t('finance.sale_invoices.delete.invoice_deleted'),
          })
          if (callback) callback()
        }

        track(trackingEvents.accounting.saleInvoices.delete)
      },
    })
  }

  return { showArchiveSaleInvoiceDialog }
}
